<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('refundDate') }" class="colStyle">
      {{ items.date }}
    </div>
    <div v-bind:style="{ width: getWidth('customerId') }" class="colStyle">
      {{ items.sale.customer.rep }}
    </div>
    <div v-bind:style="{ width: getWidth('storage.name') }" class="colStyle">
      {{ getStorageName(items.loadingStorageId) }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle">
      {{ getUserName(items.user) }}
    </div>

    <!-- ステータス -->
    <div class="yCenter">
      <span v-if="isDisplay('status')" class="yCenter operationAreaStyle">
        <span class="statusNameStyle">
          {{ getStatusName(items.status) }}
        </span>
      </span>
      <div
        v-bind:style="{ width: getWidth('amount') }"
        class="colStyle font-weight-bold text-center red--text ml-2"
      >
        {{ formatPrice(getAmount(items)).toLocaleString() + getUnit(items) }}
      </div>

      <NormalButton
        v-if="isOperation && authority.isAdmin"
        :text="$t('refund.refund_refund-cancellation')"
        class="mr-2"
        btnClass="pa-2"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="cancel"
        :disabled="complete.dialog.status.isDisabled"
      />
    </div>
  </div>
</template>
<script>
import {
  countryUtil,
  currencyUtil,
  refundUtil,
  storageUtil,
  commonUtil
} from '@/util'

import NormalButton from '@/components/items/Buttons/NormalButton'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    NormalButton
  },
  props: {
    headers: { default: [] },
    items: { default: [] },
    isOperation: { default: false }
  },
  data: () => ({
    rowDialogMethodCommonName: 'rowDialogMethodCommon',

    quickFix: {
      dialog: {
        dialog: false
      },
      pageInfoData: {}
    },
    complete: {
      dialog: {
        dialog: false,
        data: {
          id: '',
          date: ''
        },
        status: {
          name: '',
          isDisabled: false
        }
      }
    },
    ship: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    payment: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Refund', ['cancelRefund']),
    ini() {},
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getStorageName(id) {
      return storageUtil.getStorageById(id).name
    },
    getStatusName(status) {
      return refundUtil.getRefundStatusName(status)
    },
    getUnit(item) {
      return currencyUtil.findCurrencyNameById(item.currencyId).unitName
    },
    // 返金仕入在庫単価の合計を取得
    getRefundPurchaseAmount(item) {
      const sum = item.productMoves.reduce((res, cur) => {
        const tmp = cur.quantity * cur.price
        res += tmp
        return res
      }, 0)
      return (
        BigNumber(
          sum - Number(item.consumptionTax10) - Number(item.consumptionTax8)
        )
          .minus(Number(item.adjustAmount))
          .toNumber() * -1
      )
    },
    // 返金単価の合計を取得
    getAmount(item) {
      const sum = item.productMoves.reduce((res, cur) => {
        const tmp = cur.quantity * cur.refundPrice
        res += tmp
        return res
      }, 0)
      return (
        BigNumber(
          sum - Number(item.consumptionTax10) - Number(item.consumptionTax8)
        )
          .minus(Number(item.adjustAmount))
          .toNumber() * -1
      )
    },

    isDisplay(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? true : false
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    pageReload() {
      this.$emit(this.rowDialogMethodCommonName, 'reload')
    },
    async cancel(refundId) {
      const isConfirmed = confirm(`${this.$t(
        'refund.refund_refund-cancel-confirm'
      )}

対象注文番号:${this.items.sale.transaction.controlNumber}
返金管理番号: ${this.items.transaction.controlNumber}
顧客名: ${this.items.sale.customer.rep}
金額: ${this.getAmount(this.items) + this.getUnit(this.items)}

${this.$t('refund.refund_refund-cancel-continue-confirm')}`)

      if (!isConfirmed) return

      const isSucceed = await this.cancelRefund({
        refundId: this.items.refundId
      })
      if (isSucceed) {
        alert(this.$t('common.common_canceled-alert'))
        this.pageReload()
      }
    }
  },

  computed: {
    ...mapGetters('User', ['authority'])
  }
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
.statusNameStyle {
  width: 50px;
}
.operationAreaStyle {
  width: 80px;
}
</style>
